import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="row">
                <br/>
                <br/>
                <div className="col-xs-12">
                    <div className="panel-custom-wrapper">
                        <div className="panel panel-custom">
                            <div className="panel-body text-center">
                                <h3>Coming soon...</h3>

                                <p>This page is not available yet.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/errors/containers/NotFound.js